import { DrawerModule as DrawerModuleStruct } from '@/Store/interfaces/drawer';

const DrawerModule: DrawerModuleStruct = {
  state: {
    visible: false,
  },
  mutations: {
    SET_DRAWER(state: any, payload: boolean): void {
      state.visible = payload
    },
  },
}

export default DrawerModule;
